import { useTenantDetailsContext } from '../TenantDetailsContext';

/**
 * Whether the IdP ID field can be set/edited on the employee create/edit modal.
 * Gated by a tenant configuration flag managed in Settings → Internal →
 * Configurations. Defaults to disabled when the configuration is not present.
 */
export function useEmployeeIdpIdEnabled(): boolean {
  const { applicationConfiguration } = useTenantDetailsContext();
  return !!applicationConfiguration?.enableEmployeeIdpID;
}
